var render = function render(){var _vm=this,_c=_vm._self._c;return _c('copyable-field',{attrs:{"data-testid":"copy-forward-email","name":_vm.s__('RightSidebar|Issue email'),"clipboard-tooltip-text":_vm.s__('RightSidebar|Copy email address'),"value":_vm.issueEmailAddress}})
}
var staticRenderFns = []

export { render, staticRenderFns }